import MainLayout from "@/layouts/Main.vue";
import BlankLayout from "@/layouts/Blank.vue";
import LoginLayout from "@/layouts/Login.vue";

import Login from "@/pages/Login.vue";
import Logout from "@/pages/Logout.vue";

import Dashboard from "@/pages/dashboard/Dashboard.vue";

import ServiceList from "@/pages/services/List.vue";
import ServiceView from "@/pages/services/View.vue";
import ServiceBuilder from "@/pages/services/Builder.vue";

import OrderList from "@/pages/orders/List.vue";
import OrderView from "@/pages/orders/View.vue";

import AccountList from "@/pages/account/List.vue";
import AccountView from "@/pages/account/View.vue";
import UserView from "@/pages/user/View.vue";

import Mailings from "@/pages/options/Mailings.vue";
import StaticList from "@/pages/options/static/List.vue";
import StaticEdit from "@/pages/options/static/Edit.vue";


let authPages = {
  path: "/auth",
  component: LoginLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    }
  ]
};

let optionPages = {
  path: "/options",
  component: MainLayout,
  name: "Options",
  redirect: "/options/mailings",
  children: [
    {
      path: "mailings",
      component: Mailings,
      name: "Mailings",
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: "static",
      component: BlankLayout,
      name: "Static List",
      meta: {
        requiresAuth: true,
      },
      redirect: "/options/static/list",
      children: [
        {
          path: "list",
          component: StaticList,
          name: "Static List",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "create",
          component: StaticEdit,
          name: "Static Create",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          component: StaticEdit,
          name: "Static Edit",
          meta: {
            requiresAuth: true,
          },
        }
      ]
    },
  ]
};


let orderPages = {
  path: "/orders",
  component: MainLayout,
  name: "Order",
  redirect: "/orders/list",
  children: [
    {
      path: "list",
      component: OrderList,
      name: "Order list",
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: "view/:id",
      component: OrderView,
      name: "Order  View",
      meta: {
        requiresAuth: true
      }
    },
  ]
};

let servicePages = {
  path: "/services",
  component: MainLayout,
  name: "Service",
  redirect: "/services/list",
  children: [
    {
      path: "list",
      component: ServiceList,
      name: "Services List",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "view/:id",
      component: ServiceView,
      name: "Services View",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "view/:id/builder",
      component: ServiceBuilder,
      name: "Services Builder",
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let agencePages = {
  path: "/account",
  component: MainLayout,
  name: "Agence",
  redirect: "/account/list",
  children: [
    {
      path: "list",
      component: AccountList,
      name: "Compte List",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "view/:id",
      component: AccountView,
      name: "Compte Detail",
      meta: {
        requiresAuth: true
      }
    },
  ]
}

let userPages = {
  path: "/user",
  component: MainLayout,
  name: "User",
  children: [
    {
      path: "view/:id",
      component: UserView,
      name: "User Detail",
      meta: {
        requiresAuth: true
      }
    }
  ]
}

const routes = [
  {
    path: "/",
    component: MainLayout,
    name: "Home",
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
    ],
  },
  authPages,
  servicePages,
  optionPages,
  orderPages,
  agencePages,
  userPages
];

export default routes;